(function () {
  'use strict';

  var CONFIG = {
    maxLength: 12,
    allowedPattern: /^[a-zA-Z0-9\s!@#$%^&*()_\-.,'"]*$/
  };

  var drawer = null;
  var moneyFormat = '${{amount}}';
  var productData = null;
  var currentVariantId = null;
  var editContext = null;
  var quantity = 1;
  var isOpen = false;

  var els = {};

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function setFormattedMoney(element, formatted, cents) {
    if (!element) return;
    if (formatted) {
      element.innerHTML = formatted;
      return;
    }
    element.textContent = formatMoney(cents);
  }

  function getDrawer() {
    if (!drawer) {
      drawer = document.getElementById('RabitatQuickAddDrawer');
      if (drawer) {
        moneyFormat = drawer.getAttribute('data-money-format') || moneyFormat;
        cacheElements();
        bindDrawerEvents();
      }
    }
    return drawer;
  }

  function cacheElements() {
    els.overlay = drawer.querySelector('.rabitat-quick-add__overlay');
    els.panel = drawer.querySelector('.rabitat-quick-add__panel');
    els.title = drawer.querySelector('[data-quick-add-title]');
    els.content = drawer.querySelector('[data-quick-add-content]');
    els.footer = drawer.querySelector('.rabitat-quick-add__footer');
    els.variantName = drawer.querySelector('[data-quick-add-variant-name]');
    els.image = drawer.querySelector('[data-quick-add-image]');
    els.overlays = drawer.querySelector('[data-quick-add-overlays]');
    els.variantsWrap = drawer.querySelector('[data-quick-add-variants]');
    els.variantList = drawer.querySelector('[data-quick-add-variant-list]');
    els.price = drawer.querySelector('[data-quick-add-price]');
    els.compare = drawer.querySelector('[data-quick-add-compare]');
    els.discount = drawer.querySelector('[data-quick-add-discount]');
    els.personalizeWrap = drawer.querySelector('[data-quick-add-personalize]');
    els.personalizeHeading = drawer.querySelector('[data-quick-add-personalize-heading]');
    els.slots = drawer.querySelector('[data-quick-add-slots]');
    els.error = drawer.querySelector('[data-quick-add-error]');
    els.qtyValue = drawer.querySelector('[data-quick-add-qty-value]');
    els.qtyMinus = drawer.querySelector('[data-quick-add-qty-minus]');
    els.qtyPlus = drawer.querySelector('[data-quick-add-qty-plus]');
    els.submit = drawer.querySelector('[data-quick-add-submit]');
    els.viewProduct = drawer.querySelector('[data-quick-add-view-product]');
  }

  function bindDrawerEvents() {
    drawer.querySelectorAll('[data-quick-add-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    if (els.qtyMinus) {
      els.qtyMinus.addEventListener('click', function () {
        quantity = Math.max(1, quantity - 1);
        els.qtyValue.textContent = String(quantity);
      });
    }

    if (els.qtyPlus) {
      els.qtyPlus.addEventListener('click', function () {
        quantity += 1;
        els.qtyValue.textContent = String(quantity);
      });
    }

    if (els.submit) {
      els.submit.addEventListener('click', handleAddToCart);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        close();
      }
    });
  }

  function getVariantById(id) {
    if (!productData || !productData.variants) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (String(productData.variants[i].id) === String(id)) {
        return productData.variants[i];
      }
    }
    return null;
  }

  function getPersonalizationData(variantId) {
    if (!productData || !productData.personalization) return null;
    return productData.personalization[String(variantId)] || productData.personalization[variantId] || null;
  }

  function applyTextStyle(element, textStyle) {
    if (!element || !textStyle) return;
    element.style.position = 'absolute';
    element.style.bottom = textStyle.bottom || '15%';
    element.style.top = textStyle.top || 'auto';
    element.style.left = textStyle.left || '50%';
    element.style.right = textStyle.right || 'auto';
    element.style.transform = textStyle.transform || 'translateX(-50%)';
    element.style.fontSize = textStyle.fontSize || '14px';
    element.style.color = textStyle.color || '#808080';
    element.style.fontWeight = textStyle.fontWeight || '500';
    element.style.letterSpacing = textStyle.letterSpacing || '-0.5px';
    element.style.writingMode = textStyle.writingMode || 'horizontal-tb';
  }

  function buildPersonalizationSlots(pData) {
    if (!els.slots || !pData) return;
    els.slots.innerHTML = '';
    els.overlays.innerHTML = '';

    var slots = pData.slots && pData.slots.length ? pData.slots : [{
      label: 'Product 1',
      maxCharacters: pData.maxCharacters || CONFIG.maxLength,
      textStyle: pData.textStyle || {}
    }];

    slots.forEach(function (slot, index) {
      var slotNum = index + 1;
      var overlay = document.createElement('div');
      overlay.className = 'rabitat-quick-add__text-overlay';
      overlay.setAttribute('data-slot', String(slotNum));
      applyTextStyle(overlay, slot.textStyle);
      els.overlays.appendChild(overlay);

      var wrap = document.createElement('div');
      wrap.className = 'rabitat-quick-add__slot';

      var label = document.createElement('label');
      label.className = 'rabitat-quick-add__slot-label';
      label.setAttribute('for', 'quickAddInput' + slotNum);
      label.textContent = slot.label || 'Product ' + slotNum;

      var inputWrap = document.createElement('div');
      inputWrap.className = 'rabitat-quick-add__input-wrap';

      var input = document.createElement('input');
      input.type = 'text';
      input.id = 'quickAddInput' + slotNum;
      input.className = 'rabitat-quick-add__input';
      input.placeholder = 'Your engraving name';
      input.autocomplete = 'off';
      input.maxLength = slot.maxCharacters || CONFIG.maxLength;
      input.setAttribute('data-slot', String(slotNum));

      var counter = document.createElement('span');
      counter.className = 'rabitat-quick-add__char-count';
      counter.innerHTML = '0/' + (slot.maxCharacters || CONFIG.maxLength);

      input.addEventListener('input', function () {
        overlay.textContent = input.value;
        counter.textContent = input.value.length + '/' + input.maxLength;
        if (els.error) {
          els.error.hidden = true;
          els.error.textContent = '';
        }
      });

      inputWrap.appendChild(input);
      inputWrap.appendChild(counter);
      wrap.appendChild(label);
      wrap.appendChild(inputWrap);
      els.slots.appendChild(wrap);
    });
  }

  function renderVariant(variantId) {
    var variant = getVariantById(variantId);
    if (!variant) return;

    currentVariantId = variant.id;
    quantity = 1;
    if (els.qtyValue) els.qtyValue.textContent = '1';

    var pData = getPersonalizationData(variant.id);
    var displayImage = variant.image;

    if (pData && pData.image) {
      displayImage = pData.image;
    }

    if (els.image) {
      els.image.src = displayImage || '';
      els.image.alt = productData.title || '';
    }

    if (els.price) {
      setFormattedMoney(els.price, variant.price_formatted, variant.price);
    }

    if (els.compare) {
      if (variant.compare_at_price > variant.price) {
        setFormattedMoney(els.compare, variant.compare_formatted, variant.compare_at_price);
        els.compare.hidden = false;
      } else {
        els.compare.innerHTML = '';
        els.compare.hidden = true;
      }
    }

    if (els.discount) {
      if (variant.compare_at_price > variant.price) {
        var discountPercent = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        els.discount.textContent = discountPercent + '% Off';
        els.discount.hidden = false;
      } else {
        els.discount.textContent = '';
        els.discount.hidden = true;
      }
    }

    if (els.variantName) {
      els.variantName.textContent = variant.name || '';
    }

    if (els.variantList) {
      els.variantList.querySelectorAll('[data-variant-id]').forEach(function (btn) {
        var selected = String(btn.getAttribute('data-variant-id')) === String(variant.id);
        btn.classList.toggle('is-selected', selected);
      });
    }

    if (productData.personalizable && pData) {
      if (els.personalizeWrap) els.personalizeWrap.hidden = false;
      var heading = productData.id === 9081101943007 ? 'Customize' : 'Personalize';
      if (els.personalizeHeading) els.personalizeHeading.textContent = heading;
      buildPersonalizationSlots(pData);
    } else {
      if (els.personalizeWrap) els.personalizeWrap.hidden = true;
      if (els.slots) els.slots.innerHTML = '';
      if (els.overlays) els.overlays.innerHTML = '';
    }

    if (els.viewProduct && variant.url) {
      els.viewProduct.href = variant.url;
    }

    if (els.submit) {
      els.submit.disabled = !variant.available;
      if (editContext) {
        els.submit.textContent = 'Save personalization';
      } else {
        els.submit.textContent = variant.available ? (productData.cart_label || 'Add To Cart') : (productData.sold_out_label || 'Sold out');
      }
    }
  }

  function renderVariantButtons() {
    if (!els.variantList || !productData || !productData.variants) return;

    els.variantList.innerHTML = '';
    var showVariants = productData.variants.length > 1;

    if (els.variantsWrap) {
      els.variantsWrap.hidden = !showVariants;
    }

    if (!showVariants) return;

    productData.variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rabitat-quick-add__variant-btn';
      btn.setAttribute('data-variant-id', String(variant.id));
      btn.setAttribute('aria-label', variant.name || 'Variant');
      btn.disabled = !variant.available;

      if (variant.image) {
        var thumb = document.createElement('img');
        thumb.className = 'rabitat-quick-add__variant-thumb';
        thumb.src = variant.image;
        thumb.alt = variant.name || '';
        thumb.loading = 'lazy';
        btn.appendChild(thumb);
      }

      btn.addEventListener('click', function () {
        renderVariant(variant.id);
      });

      els.variantList.appendChild(btn);
    });
  }

  function open(data, variantId, options) {
    var root = getDrawer();
    if (!root || !data) return;

    var opts = options || {};
    editContext =
      opts.lineKey
        ? {
            lineKey: opts.lineKey,
            quantity: opts.quantity || 1
          }
        : null;

    productData = data;
    currentVariantId = variantId || (data.variants[0] && data.variants[0].id);
    quantity = 1;

    if (els.title) els.title.textContent = data.title || '';
    if (els.error) {
      els.error.hidden = true;
      els.error.textContent = '';
    }

    renderVariantButtons();

    var initialVariant = getVariantById(currentVariantId);
    if (!initialVariant || !initialVariant.available) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          currentVariantId = data.variants[i].id;
          break;
        }
      }
    }

    renderVariant(currentVariantId);

    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });

    isOpen = true;
    document.body.style.overflow = 'hidden';

    if (els.submit) {
      els.submit.focus();
    }
  }

  function close() {
    var root = getDrawer();
    if (!root || !isOpen) return;

    root.classList.remove('is-open');
    isOpen = false;
    document.body.style.overflow = '';

    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      productData = null;
      currentVariantId = null;
      editContext = null;
    }, 300);
  }

  function getPersonalizationTexts() {
    var texts = [];
    if (!els.slots) return texts;

    els.slots.querySelectorAll('.rabitat-quick-add__input').forEach(function (input) {
      texts.push(input.value.trim());
    });

    return texts;
  }

  function validatePersonalization(texts, pData) {
    if (!pData) return { valid: true, texts: texts };

    var slots = pData.slots && pData.slots.length ? pData.slots : [{ maxCharacters: CONFIG.maxLength }];
    var hasAnyText = texts.some(function (t) { return t.length > 0; });

    if (!hasAnyText) {
      return { valid: true, texts: texts, withPersonalization: false };
    }

    for (var i = 0; i < texts.length; i++) {
      var text = texts[i];
      if (!text) continue;

      var maxChars = (slots[i] && slots[i].maxCharacters) || CONFIG.maxLength;
      if (text.length > maxChars) {
        return { valid: false, message: 'Text exceeds maximum length for slot ' + (i + 1) + '.' };
      }

      if (!CONFIG.allowedPattern.test(text)) {
        return { valid: false, message: 'Only alphabets, numbers, and select special characters are allowed.' };
      }
    }

    return { valid: true, texts: texts, withPersonalization: true };
  }

  function getCartPropertyKey(slotIndex, slotCount) {
    if (slotCount === 1) return 'Personalization';
    return 'Personalization ' + (slotIndex + 1);
  }

  function handleAddToCart() {
    var variant = getVariantById(currentVariantId);
    if (!variant || !variant.available) return;

    var pData = getPersonalizationData(variant.id);
    var texts = getPersonalizationTexts();
    var validation = validatePersonalization(texts, productData.personalizable ? pData : null);

    if (!validation.valid) {
      if (els.error) {
        els.error.textContent = validation.message;
        els.error.hidden = false;
      }
      return;
    }

    var properties = {
      engraving_required: validation.withPersonalization ? 'true' : 'false',
      image_url: variant.image || ''
    };

    if (validation.withPersonalization) {
      for (var i = 0; i < texts.length; i++) {
        if (texts[i]) {
          properties[getCartPropertyKey(i, texts.length)] = texts[i];
        }
      }
      properties['Engraving Value'] = texts.filter(Boolean).join(' | ');
    }

    if (els.submit) {
      els.submit.disabled = true;
      els.submit.classList.add('is-loading');
    }

    var addPayload = {
      id: variant.id,
      quantity: quantity,
      properties: properties
    };

    if (editContext) {
      addPayload = {
        id: editContext.lineKey,
        quantity: editContext.quantity,
        properties: properties
      };
    }

    if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
      addPayload = window.RabitatCart.withCartSections(addPayload);
    }

    fetch(editContext ? '/cart/change.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(addPayload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function (result) {
        if (els.submit) {
          els.submit.classList.remove('is-loading');
          els.submit.disabled = !variant.available;
        }

        close();

        if (editContext) {
          if (window.RabitatCart && typeof window.RabitatCart.handleMutationResult === 'function') {
            window.RabitatCart.handleMutationResult(result, {
              open: false,
              focus: false,
              animate: false
            });
          } else if (window.RabitatCart && typeof window.RabitatCart.notifyUpdated === 'function') {
            window.RabitatCart.notifyUpdated(result);
          }
        } else if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
          window.RabitatCart.syncCartAfterAdd(result);
        } else {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              if (window.RabitatCart && typeof window.RabitatCart.notifyUpdated === 'function') {
                window.RabitatCart.notifyUpdated(cart);
              } else {
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(
                  new CustomEvent('rabitat:cart:updated', {
                    detail: { item_count: cart.item_count, cart: cart }
                  })
                );
              }
            });
        }

        if (window.injectGoKwikPreviews) {
          window.setTimeout(function () {
            window.injectGoKwikPreviews();
          }, 0);
        }
      })
      .catch(function (error) {
        console.error('Quick add error:', error);
        if (els.error) {
          els.error.textContent = (error && error.description) || 'Error adding to cart. Please try again.';
          els.error.hidden = false;
        }
      })
      .finally(function () {
        if (els.submit) {
          els.submit.classList.remove('is-loading');
          els.submit.disabled = !variant.available;
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', getDrawer);
  } else {
    getDrawer();
  }

  document.addEventListener('rabitat:quick-add:open', function (event) {
    if (!event.detail || !event.detail.data) return;
    open(event.detail.data, event.detail.variantId, event.detail.options);
  });

  window.RabitatQuickAdd = {
    open: open,
    close: close
  };
})();
